<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <div
      class="w-100 d-flex flex-column justify-content-between align-items-center"
      style="padding: 24px; margin-top: 82px"
    >
      <span class="pageSteps card-styling">
        <p style="font-weight: 300; font-style: normal">Dashboard</p>

        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />

        <p style="font-style: normal; font-weight: 500">Postagens</p>
      </span>

      <div id="divTable" style="margin-top: 32px">
        <section
          class="d-flex justify-content-between align-items-center w-100 flex-wrap"
        >
          <div
            style="
              background: #f0f2f8;
              border-radius: 8px;
              width: 310px;
              height: 42px;
              max-width: 310px;
            "
            class="d-flex align-items-center justify-content-between"
          >
            <InputSearch
              @onUpdate="(value) => publishedByName(value)"
              v-if="isPublicadas"
            />
            <InputSearch @onUpdate="(value) => scheduledByName(value)" v-else />

            <!-- <img
                :src="require(`@/assets/images/svg/iconLupa.svg`)"
                alt=""
                style="border-radius: 8px"
                class="img-postagem"
              /> -->
          </div>
          <span
            v-if="isPublicadas"
            class="d-flex flex-column justify-content-center align-items-center text-uppercase"
            style="
              background: #d3e7fb;
              border-radius: 4px;
              width: 298.5px;
              padding: 8px 0px;
              max-width: 298.5px;
              cursor: default;
            "
          >
            <p
              class="m-0"
              style="font-weight: 600; color: #2485ea; font-size: 14px"
            >
              Publicadas
            </p>
            <p
              class="m-0 text-uppercase"
              style="color: #61adf0; font-size: 14px; font-weight: 300"
            >
              ({{ totalPublished }} Publicações)
            </p>
          </span>
          <span
            v-else
            style="
              cursor: pointer;
              color: #383838;
              font-weight: 500;
              font-size: 14px;
            "
            class="text-uppercase"
            v-on:click="exibirOcultar(true)"
          >
            Publicadas
          </span>
          <span
            v-if="!isPublicadas"
            class="d-flex flex-column justify-content-center align-items-center text-uppercase"
            style="
              background: #d3e7fb;
              border-radius: 4px;
              width: 298.5px;
              padding: 8px 0px;
              max-width: 298.5px;
              cursor: default;
            "
          >
            <p
              class="m-0"
              style="font-weight: 600; color: #2485ea; font-size: 14px"
            >
              Agendadas
            </p>
            <p
              class="m-0 text-uppercase"
              style="color: #61adf0; font-size: 14px; font-weight: 300"
            >
              ({{ totalScheduled }} Publicações)
            </p>
          </span>
          <span
            v-else
            style="
              cursor: pointer;
              color: #383838;
              font-weight: 500;
              font-size: 14px;
            "
            class="text-uppercase"
            v-on:click="exibirOcultar(false)"
          >
            Agendadas
          </span>

          <button
            class="btn"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#modalPostType"
            style="
              background: var(--blue-medium);
              border-radius: 8px;
              color: var(--white);
              font-weight: 500;
              font-size: 16px;
              height: 48px;
              width: 193px;
              max-width: 193px;
            "
          >
            Criar Novo
          </button>
        </section>
        <div class="table-responsive w-100" v-if="isPublicadas">
          <table class="table align-middle">
            <thead class="thead">
              <tr style="height: 50px">
                <th>Postagens</th>
                <th>Tipo</th>
                <th>Alcance</th>
                <th>Impressões</th>
                <th>Curtidas</th>
                <th>Comentários</th>
                <th>Salvos</th>
                <th>Visualizações do Vídeos</th>
                <th>Criado em</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in published" :key="item.id">
                <td>
                  <div class="d-flex align-items-center flex-wrap">
                    <img
                      v-if="
                        item.mediaType == 'CAROUSEL_ALBUM' ||
                        item.mediaType == 'IMAGE'
                      "
                      :src="
                        item.mediaUrl != null
                          ? item.mediaUrl
                          : item.instagramMediaContainers[0].mediaUrl
                      "
                      alt="image"
                      style="
                        border-radius: 8px;
                        max-width: 20%;
                        margin-right: 10px;
                      "
                      class="img-postagem"
                    />

                    <video
                      v-else
                      :src="
                        item.mediaUrl != null
                          ? item.mediaUrl
                          : item.instagramMediaContainers[0].mediaUrl
                      "
                      alt="image video"
                      class="img-postagem"
                      style="
                        border-radius: 8px;
                        max-width: 20%;
                        margin-right: 10px;
                      "
                    />
                    <span
                      class="d-flex flex-column align-items-start justify-content-between"
                    >
                      <b style="margin-bottom: 8px" class="short-text">
                        {{ item.caption }}
                      </b>
                    </span>
                  </div>
                </td>
                <td v-if="item.mediaType == 'IMAGE'">Imagem</td>
                <td v-if="item.mediaType == 'VIDEO'">Video</td>
                <td v-if="item.mediaType == 'CAROUSEL_ALBUM'">Carrosel</td>
                <td>{{ item.reachCount }}</td>
                <td>{{ item.impressionsCount }}</td>
                <td>{{ item.likeCount }}</td>
                <td>{{ item.commentsCount }}</td>
                <td>{{ item.savedCount }}</td>
                <td class="text-center">-</td>
                <td>{{ currentDateTime(item.timestamp) }}</td>
                <td class="text-center">
                  <router-link
                    v-if="item.instaMediaId"
                    :to="{
                      name: 'Details',
                      params: { id: item.instaMediaId },
                    }"
                  >
                    <img
                      :src="
                        require(`@/assets/images/svg/ícone-seta-direita-azul.svg`)
                      "
                      alt=""
                    />
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :count="totalPublished"
            :offset="offset"
            @firstPage="pagination('clickFirstPage', false)"
            @previousPage="pagination('clickPreviousPage', false)"
            @nextPage="pagination('clickNextPage', false)"
            @lastPage="pagination('clickLastPage', false)"
          />
        </div>
        <!-- <PostagensAgendadas @pushDetalhes="pushDetalhes()" v-else /> -->
        <div class="table-responsive w-100" v-else>
          <table class="table align-middle">
            <thead class="thead">
              <tr style="height: 50px">
                <th style="width: 25rem">Postagens</th>
                <th>Descrição</th>
                <th>Tipo</th>
                <th>Agendado Para</th>
                <th>Criado em</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in scheduled" :key="item.id">
                <td>
                  <div class="d-flex align-items-center flex-wrap">
                    <img
                      :src="item.mediasContainers[0].mediaUrl"
                      alt=""
                      style="
                        border-radius: 8px;
                        max-width: 20%;
                        margin-right: 10px;
                      "
                      class="img-postagem"
                    />
                    <span
                      v-if="item.caption === String"
                      class="d-flex flex-column align-items-start justify-content-between"
                    >
                      <b style="margin-bottom: 8px">{{ item.caption }}</b>
                      <p class="m-0">
                        {{ item.instaPageName ? item.instaPageName : "-" }}
                      </p>
                    </span>
                  </div>
                </td>
                <td>{{ item.caption }}</td>
                <td>{{ item.mediaType }}</td>
                <td>{{ currentDateTime(item.scheduleDate) }}</td>
                <td>{{ currentDateTime(item.timestamp) }}</td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :count="totalScheduled"
            :offset="offset"
            @firstPage="pagination('clickFirstPage', true)"
            @previousPage="pagination('clickPreviousPage', true)"
            @nextPage="pagination('clickNextPage', true)"
            @lastPage="pagination('clickLastPage', true)"
          />
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modalPostType"
      tabindex="-1"
      aria-labelledby="modalPostTypeLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content align-items-center">
          <div class="modal-header border-0" style="width: 80%"></div>
          <div class="modal-body" style="width: 80%">
            <h2
              class="modal-title"
              id="modalPostTypeLabel"
              style="
                font-style: normal;
                font-weight: 700;
                font-size: 34px;
                color: var(--black-medium);
              "
            >
              Escolha Tipo
            </h2>
            <p
              style="
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                color: var(--grey-medium);
              "
            >
              Escolha o tipo de publicação que deseja utilizar para a sua
              postagem
            </p>
          </div>
          <div
            class="modal-footer border-0 justify-content-center"
            style="width: 80%; margin-bottom: 16px"
          >
            <button
              v-if="isADM"
              @click="pushNewPost"
              style="
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                color: var(--white);
                background-color: var(--blue-medium);
                text-align: center;
              "
              class="text-decoration-none btn-default"
            >
              Comum
            </button>
            <button
              @click="pushNewPostMarketing"
              style="
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                color: var(--white);
                background-color: var(--blue-medium);
                text-align: center;
              "
              class="text-decoration-none btn-default"
            >
              Marketing na Loja
            </button>
            <button
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeModalPostType"
              class="btn"
              style="
                background-color: transparent;
                outline: none;
                color: var(--blue-medium);
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
              "
            >
              Voltar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputSearch from "@/components/InputSearch.vue";
import Pagination from "@/components/Pagination.vue";
import moment from "moment/moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Loading from "vue-loading-overlay";
import apiGerenciarMidiasService from "../service/apiGerenciarMidiasService";

export default {
  components: { InputSearch, Pagination, Loading },
  data() {
    return {
      isPublicadas: true,
      isLoading: false,
      totalScheduled: 0,
      totalPublished: 0,
      offset: 0,
      offsetAgendada: 0,
      namePublishedToSearch: "",
      nameScheduledToSearch: "",
      limitAgendada: 0,
      scheduled: [],
      published: [],
      user: {
        roles: [],
      },
      isADM: false,
    };
  },
  async created() {
    this.isLoading = true;

    // inicio postagem punlicadas
    let responsePublished = [];
    responsePublished = await apiGerenciarMidiasService.getAllMedias({
      isPosts: true,
      isScheduled: false,
      offset: 0,
      name: this.namePublishedToSearch,
      limit: 5,
    });

    if (responsePublished.status === 200 && this.isPublicadas) {
      this.totalPublished = responsePublished.data.count;
      this.published = responsePublished.data.data;
    }
    //fim postagem publicadas

    //inicio postagem agendada
    const responseScheduled =
      await apiGerenciarMidiasService.getScheduledMedias({
        isPosts: true,
        isScheduled: true,
        offset: 0,
        name: this.nameScheduledToSearch,
        limit: 5,
      });

    if (responseScheduled.status === 200) {
      this.totalScheduled = responseScheduled.data.count;
      this.scheduled = responseScheduled.data.data;
    }

    //fim postagem agendada

    this.getUser();
    this.isLoading = false;
  },
  computed: {
    ...mapGetters(["getOffset"]),
  },
  methods: {
    ...mapMutations(["SET_OFFSET"]),
    ...mapActions(["getUserByEmail"]),

    currentDateTime(timestamp) {
      return moment(timestamp).format("DD/MM/YYYY");
    },
    pushNewPost() {
      this.$refs.closeModalPostType.click();
      return this.$router.push({ name: "NewPost" });
    },
    pushNewPostMarketing() {
      this.$refs.closeModalPostType.click();
      return this.$router.push({ name: "NewPostMarketing" });
    },
    exibirOcultar(value) {
      this.isPublicadas = value;
    },
    publishedByName: function publishedByName(name) {
      this.namePublishedToSearch = name;

      if (this.namePublishedToSearch != "") {
        let objThis = this;

        clearTimeout(publishedByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage", false);
        }, 500);
      } else {
        this.pagination("clickFirstPage", false);
      }
    },
    scheduledByName: function scheduledByName(name) {
      this.nameScheduledToSearch = name;

      if (this.nameScheduledToSearch != "") {
        let objThis = this;

        clearTimeout(scheduledByName);

        setTimeout(function () {
          objThis.paginationAgendada("clickFirstPage", true);
        }, 500);
      } else {
        this.paginationAgendada("clickFirstPage", true);
      }
    },
    async pagination(action, isScheduled) {
      const data = {
        action: action,
        isPosts: true,
        isScheduled: !isScheduled ? false : true,
        name: !isScheduled
          ? this.namePublishedToSearch
          : this.nameScheduledToSearch,
        offset: 0,
        limit: 5,
      };

      switch (action) {
        case "clickFirstPage": {
          this.isLoading = true;
          this.offset = 0;
          this.SET_OFFSET(0);
          if (this.isPublicadas) {
            await apiGerenciarMidiasService
              .getAllMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          } else {
            await apiGerenciarMidiasService
              .getScheduledMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          }
        }
        case "clickPreviousPage": {
          this.isLoading = true;
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          if (this.isPublicadas) {
            await apiGerenciarMidiasService
              .getAllMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          } else {
            await apiGerenciarMidiasService
              .getScheduledMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          }
        }
        case "clickNextPage": {
          this.isLoading = true;
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          if (this.isPublicadas) {
            await apiGerenciarMidiasService
              .getAllMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          } else {
            await apiGerenciarMidiasService
              .getScheduledMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          }
        }
        case "clickLastPage": {
          this.isLoading = true;
          let lastPage;
          let total = !isScheduled ? this.totalPublished : this.totalScheduled;

          if (total % data.limit === 0) {
            lastPage = total - data.limit;
          } else {
            lastPage = Math.floor(total / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          if (this.isPublicadas) {
            await apiGerenciarMidiasService
              .getAllMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          } else {
            await apiGerenciarMidiasService
              .getScheduledMedias(data)
              .then((response) => {
                if (isScheduled) {
                  this.totalScheduled = response.data.count;
                  this.scheduled = response.data.data;
                } else {
                  this.totalPublished = response.data.count;
                  this.published = response.data.data;
                }

                this.isLoading = false;
              });

            break;
          }
        }
        default: {
          break;
        }
      }
    },
    async getUser() {
      await this.getUserByEmail().then((response) => {
        const data = response.data.data[0];
        this.user.roles = data.roles;
      });

      if (this.user.roles.includes("Administrador")) {
        this.isADM = true;
      } else {
        this.isADM = false;
      }
    },
    pushDetailsAgendada(id, date) {
      this.$router.push({ name: "DetailsAgendada", params: { id: id } });
    },
  },
};
</script>
<style scoped>
#divTable {
  width: 100%;
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 24px 16px 24px 32px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  margin-bottom: 22px;
}

.table {
  margin: 0;
}

.table td,
.table th {
  vertical-align: middle;
}

.table th {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--grey-medium);
  text-align: start;
}

thead.thead {
  border-color: var(--blue-light);
}

tbody tr:nth-last-child(even) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}

tbody tr:nth-last-child(odd) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}

.short-text {
  max-width: 35ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
